// extracted by mini-css-extract-plugin
export var editButton = "_n8-0";